import React from 'react';
import Icon from '@mdi/react';
import { mdiAccount, mdiLock } from '@mdi/js';

const LoginTextInput = ({
  input,
  width,
  type,
  icon,
  disabled,
  readOnly,
  placeholder,
  label,
  meta: { touched, error, active },
}) => {
  return (
    <div className='field'>
      <label className='label is-size-7'>{label}</label>
      <div className='control has-icons-left'>
        <input
          {...input}
          className={
            touched && !!error
              ? 'input is-danger is-small is-rounded'
              : 'input is-small is-rounded'
          }
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
        />
        <span className='icon is-small is-left'>
          {icon === 'account' && <Icon path={mdiAccount} size={0.7} />}
          {icon === 'lock' && <Icon path={mdiLock} size={0.6} />}
        </span>
      </div>
      {touched && error && <p className='help is-danger'>{error}</p>}
    </div>
  );
};

export default LoginTextInput;
